var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7207",
    "data-name": "Group 7207",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6210",
    "data-name": "Rectangle 6210",
    width: 42,
    height: 42,
    rx: 5,
    fill: "#edeef3",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5345",
    "data-name": "Group 5345",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4777",
    "data-name": "Path 4777",
    d: "M0,0H26V26H0Z",
    fill: "rgba(203,203,203,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4778",
    "data-name": "Path 4778",
    d: "M11.889,18h2.222a1.006,1.006,0,1,0,0-2H11.889a1.006,1.006,0,1,0,0,2ZM3,7A1.063,1.063,0,0,0,4.111,8H21.889A1.063,1.063,0,0,0,23,7a1.063,1.063,0,0,0-1.111-1H4.111A1.063,1.063,0,0,0,3,7Zm4.444,6H18.556a1.063,1.063,0,0,0,1.111-1,1.063,1.063,0,0,0-1.111-1H7.444a1.063,1.063,0,0,0-1.111,1A1.063,1.063,0,0,0,7.444,13Z",
    transform: "translate(0 1)",
    fill: "#242424",
    stroke: "#242424",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.6f1cffd29df4fc7597471545ffef9d61.svg";
export { ForwardRef as ReactComponent };